import { Clock, Download, Github, MessageSquare, Shield, Star, Tag, User } from "lucide-react";
import type { ReactNode } from "react";
import { RiskBadge } from "@/components/skills/RiskBadge";
import type { SkillDetail } from "@/hooks/use-skill";
import { timeAgo } from "@/lib/skills/time-ago";

export function TrustSignals({ skill }: { skill: SkillDetail }) {
  const rows: { icon: typeof Shield; label: string; value: ReactNode }[] = [
    { icon: Shield, label: "Risk status", value: <RiskBadge level={skill.risk} /> },
    {
      icon: Star,
      label: "Rating",
      value: `${skill.rating.toFixed(1)} · ${skill.ratingCount} ratings`,
    },
    { icon: MessageSquare, label: "Reviews", value: skill.reviews.length },
    { icon: Download, label: "Downloads", value: skill.downloads.toLocaleString() },
    { icon: Tag, label: "Version", value: <span className="font-mono">{skill.version}</span> },
    { icon: Clock, label: "Updated", value: timeAgo(new Date(skill.updatedAt)) },
    { icon: User, label: "Author", value: skill.authorName },
  ];
  return (
    <div>
      <div className="flex flex-col">
        {rows.map((r) => {
          const Icon = r.icon;
          return (
            <div
              key={r.label}
              className="flex items-center justify-between border-b border-border-1 py-2.5 last:border-0"
            >
              <span className="flex items-center gap-2 text-sm font-semibold text-fg-3">
                <Icon className="size-4 text-fg-3" />
                {r.label}
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-fg-1">
                {r.value}
              </span>
            </div>
          );
        })}
      </div>
      {skill.github ? (
        <a
          href={`https://github.com/${skill.github}`}
          target="_blank"
          rel="noreferrer"
          className="mt-3.5 flex items-center justify-center gap-2 rounded-[9px] border border-border-1 bg-bg-3 px-3 py-2 text-sm font-medium text-fg-1 hover:bg-bg-2"
        >
          <Github className="size-4" />
          {skill.github}
        </a>
      ) : null}
    </div>
  );
}
